/* eslint-disable jsx-a11y/anchor-is-valid */
import CloseIcon from '@mui/icons-material/Close';
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BASE_URLS } from "../../../../config/appConfig";
import { AppRoutes } from "../../../../constants/appRoutes";
import { Logout } from "../../../../services/authService";
import { LanguageService } from "../../../../services/languageService";

export const SwitchToSaudiDialog = ({ onClose, isShow = false }) => {
  const languageService = new LanguageService();
  const { t } = useTranslation();

  const isAr = () => languageService.isArabic();
  const onNavigateToKSA = () => {
    Logout();
    let saudiInvestorUrl = `${BASE_URLS.sa}/${isAr() ? 'ar' : 'en'}/${AppRoutes.InvestorRegistration}/register`;
    window.open(saudiInvestorUrl, "_self");
    onClose();
  };

  return <Box className={`popup-ksa-residence-overlay ${isShow ? 'show-ksa-popup' : ''} right-auto left-auto ${!isAr() ? 'md:!right-[10px]' : 'md:!left-[10px]'}`}>
    <Box className={`popup-ksa-residence md:!w-[320px] !w-auto flex flex-col -left-[12px] md:left-[0px]`}>
      <CloseIcon onClick={() => onClose()} className={`close-btn ${!isAr() ? 'right-[10px]' : 'left-[10px]'}`} />
      <Box className="mt-3 !font-[700] !text-[16px]">{t('interestedInInvestingInSaudi')}</Box>
      <Box className="mt-2 !font-[500]">{t('interestedInInvestingInSaudiText')}</Box>
      <Box className='flex justify-end mt-3'>
        <Box onClick={() => { onNavigateToKSA(); }} className='p-3 !py-1 !font-[500] cursor-pointer items-center rounded-md flex bg-white text-primary'>
          {t('signUpNow')}
        </Box>
      </Box>
    </Box>
  </Box>;
};